import { Component, inject, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { IEvent } from "src/app/shared/interfaces";
import { DeviceInfoService } from "src/app/shared/services";

@Component({
	selector: "app-external-link",
	templateUrl: "./external-link.component.html",
	styleUrls: ["./external-link.component.scss"],
	standalone: false
})
export class ExternalLinkComponent {
	@Input() url: string = "";
	@Input() event: IEvent;
	isMobile = inject(DeviceInfoService).isMobile;

	constructor(public modalCtrl: ModalController) {}

	dismiss() {
		this.modalCtrl.dismiss();
	}
}
